import { ComponentDocs } from "components/docs";
import { ExternalProps } from "constants/external";

const NotificationStack = () => (
  <ComponentDocs
    name="<NotificationStack/>"
    entry="NotificationStack"
    propsEntry="NotificationStackProps"
    externalProps={ExternalProps.MuiSnackbar}
  />
);

export default NotificationStack;
